module.exports = __webpack_public_path__ + "img/canvasMenuQuickStyle_1.52930b31.svg";